module.exports = __webpack_public_path__ + "static/media/Porpora-Regular.2a369aff.ttf";